// From inc/ directory
import "./inc/read_more.js";

// Formerly in vendor.footer.js
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

// =============================================================================
var seen = {},
    bedCrumbs = $('.bread-crumbs a');
bedCrumbs.each(function () {
    var txt = $(this).text();
    if (seen[txt])
        $(this).remove();
    else
        seen[txt] = true;
});
var target = $('.sub-category > div');
// Get all the classes
var classes = target.map(function () {
    return $(this).attr('class');
});
const themeReady = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};
themeReady(() => {
    let overlay = document.getElementById("iframe-overlay")
    if (overlay !== null && getCookie("ifp_signup") != null) {
        overlay.style.display = "none";
    }
});
function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    }
    else {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
            end = dc.length;
        }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
}

$(window).on("load", function () {
    setTimeout(function () {
        var siteNav = $('#site-nav');
        var subNav = $('.desktop-nav');
        // Safely handle missing elements
        var offsetNavHeight = siteNav.length ? siteNav.outerHeight() : 0;
        var offsetSubNavHeight = subNav.length ? subNav.outerHeight() : 0;
        var fullHeight = offsetNavHeight + offsetSubNavHeight;
        $('html').css('--scroll-padding-subnav', fullHeight + 'px');
        console.log('Scroll padding set to:', fullHeight + 'px');
    }, 2000); // delay 2 seconds
});

$(document).ready(function () {

    // Run scroll handler initially
    onScroll();

    // Listen for scroll
    $(document).on("scroll", onScroll);

    // Smooth scroll and add class on click (for both navs)
    $('#subnav a[href^="#"], #subnav-mobile a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        $(document).off("scroll"); // temporarily disable scroll event

        // Remove active class from both navs
        $('#subnav a, #subnav-mobile a').removeClass('bg-primary');

        // Add to clicked one
        $(this).addClass('bg-primary');

        var target = this.hash;
        var $target = $(target);

        // Smooth scroll to target
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top + 2
        }, 500, 'swing', function () {
            window.location.hash = target;
            $(document).on("scroll", onScroll); // re-enable scroll listener
        });
    });
});

function onScroll() {
    var scrollPos = $(document).scrollTop();

    // Check both navs
    $('#subnav a, #subnav-mobile a').each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));

        if (refElement.length) {
            var top = refElement.position().top;
            var bottom = top + refElement.outerHeight();

            if (top <= scrollPos && bottom > scrollPos) {
                // Remove active class from both menus
                $('#subnav a, #subnav-mobile a').removeClass("bg-primary");
                // Add to both matching links (if same href)
                $('#subnav a[href="' + currLink.attr("href") + '"], #subnav-mobile a[href="' + currLink.attr("href") + '"]').addClass("bg-primary");
            }
        }
    });
}

// =============================================================================
/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false

// Abstracted event action handler
const doFancyboxOiEvent = (fancybox) => {
    let oi_event_name = false
    // Identify the proper event name. Use the first occurence from the possibilities
    // below.
    // 1. If a trigger element is available, use the value of data-oi-event-name when
    //    present. This is the most common scenario.
    // 2. If the Fancybox options object has oiEventName attribute, use the value. Event
    //    names are define this way when Fancybox assets are populated by a javascript
    //    array, and not DOM elements are available to place the data attribute.
    if (fancybox.options.$trigger
        && fancybox.options.$trigger.dataset
        && fancybox.options.$trigger.dataset.oiEventName) {
        oi_event_name = fancybox.options.$trigger.dataset.oiEventName
    }
    if (oi_event_name) {
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}

// Define Fancybox config
window.FANCYBOX_CONFIG = {
    on: {
        initCarousel: (fancybox) => {
            if (!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true

                // Do Fancybox event
                doFancyboxOiEvent(fancybox)

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if (!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
}

// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", FANCYBOX_CONFIG)

/* END FANCYBOX */

// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function () {
    oi.utils.wrap_oi_aspect();
}, false);

/* map list toggle */

document.addEventListener('DOMContentLoaded', function () {
    // Helper: slide toggle animation
    function slideToggle(el, duration = 500) {
        if (!el) return;

        if (window.getComputedStyle(el).display === 'none') {
            el.style.removeProperty('display');
            let display = window.getComputedStyle(el).display;
            if (display === 'none') display = 'block';
            el.style.display = display;

            let height = el.scrollHeight;
            el.style.overflow = 'hidden';
            el.style.height = '0';
            el.style.transition = `height ${duration}ms ease`;

            requestAnimationFrame(() => {
                el.style.height = height + 'px';
            });

            setTimeout(() => {
                el.style.removeProperty('height');
                el.style.removeProperty('overflow');
                el.style.removeProperty('transition');
            }, duration);

        } else {
            let height = el.scrollHeight;
            el.style.height = height + 'px';
            el.style.overflow = 'hidden';
            el.style.transition = `height ${duration}ms ease`;

            requestAnimationFrame(() => el.style.height = '0');

            setTimeout(() => {
                el.style.display = 'none';
                el.style.removeProperty('height');
                el.style.removeProperty('overflow');
                el.style.removeProperty('transition');
            }, duration);
        }
    }

    // Hide .gmap on small screens
    if (window.innerWidth < 992) {
        document.querySelectorAll('.gmap').forEach(el => el.style.display = 'none');
    }

    // Map button toggle
    document.querySelectorAll('.map-button-change').forEach(button => {
        button.addEventListener('click', function () {
            const span = this.querySelector('span.show-hide-{{ record }}');
            if (span) {
                span.style.display = (span.style.display === 'none' || span.style.display === '') ? 'inline' : 'none';
            }

            const showMap = document.querySelector('.show-map');
            slideToggle(showMap);

            if (window.oi && oi.loaded && oi.loaded.map && oi.loaded.map.gmap) {
                oi.loaded.map.gmap.fit();
            } else if (typeof initialize_mobile_map === 'function') {
                initialize_mobile_map();
            }
        });
    });

    // Show grid
    const showGridBtn = document.getElementById('show-grid');
    if (showGridBtn) {
        showGridBtn.addEventListener('click', function () {
            const showMap = document.querySelector('.show-map');
            if (showMap) showMap.style.display = 'none';

            const grid = document.getElementById('grid');
            if (grid) grid.classList.add('only-grid');

            showGridBtn.classList.add('active');

            const showMapBtn = document.getElementById('show-map');
            if (showMapBtn) showMapBtn.classList.remove('active');

            document.querySelectorAll('.grid-card').forEach(el => el.classList.add('col-xl-4'));
            document.querySelectorAll('.grid-list').forEach(el => el.classList.add('col-lg-11', 'col-xl-9'));
        });
    }

    // Show map
    const showMapBtn = document.getElementById('show-map');
    if (showMapBtn) {
        showMapBtn.addEventListener('click', function () {
            const showMap = document.querySelector('.show-map');
            if (showMap) showMap.style.display = 'block';

            if (window.oi && oi.loaded && oi.loaded.map && oi.loaded.map.gmap) {
                oi.loaded.map.gmap.fit();
            } else if (typeof initialize_mobile_map === 'function') {
                initialize_mobile_map();
            }

            const grid = document.getElementById('grid');
            if (grid) grid.classList.remove('only-grid');

            showMapBtn.classList.add('active');
            if (showGridBtn) showGridBtn.classList.remove('active');

            document.querySelectorAll('.grid-card').forEach(el => el.classList.remove('col-xl-4'));
            document.querySelectorAll('.grid-list').forEach(el => el.classList.remove('col-lg-11', 'col-xl-9'));
        });
    }

    /*
    View All/Less button script
    */
    // Select all model-card-wrapper sections on the page
    document.querySelectorAll('.model-card-wrapper').forEach(wrapper => {
        const toggleButton = wrapper.querySelector('.toggle-button');
        if (!toggleButton) return; // Skip if no button

        const cards = wrapper.querySelectorAll('.row > .model-card');
        const textSpan = toggleButton.querySelector('span');

        // Skip if no cards
        if (cards.length === 0) return;

        toggleButton.addEventListener('click', () => {
            // Check if any card after the first is hidden
            const isCollapsed = Array.from(cards).some((card, i) => i > 0 && card.classList.contains('d-none'));

            if (isCollapsed) {
                // Show all cards after the first
                cards.forEach((card, i) => {
                    if (i > 0) card.classList.remove('d-none');
                });
                // Update button text and icon
                if (textSpan) textSpan.innerHTML = 'View Less <i class="fas fa-chevron-up ms-1"></i>';
            } else {
                // Hide all cards after the first
                cards.forEach((card, i) => {
                    if (i > 0) card.classList.add('d-none');
                });
                // Update button text and icon
                if (textSpan) textSpan.innerHTML = 'View All <i class="fas fa-chevron-down ms-1"></i>';
            }
        });
    });
});
